//file will be used as an index for all API calls
import CMS from './cms'
import Public from './public'
export { 
    CMS,
    Public
};



// WEBPACK FOOTER //
// ./src/api/index.js